import React from "react";

import ArtifactLoadingState from "../../../components/artifacts/ArtifactLoadingState";
import PlanArtifactView from "../views/PlanArtifactView";
import SurveyArtifactView from "../views/SurveyArtifactView";
import GuidelineArtifactView from "../views/GuidelineArtifactView";

/**
 * StudyPage의 detail-content-card 내부 콘텐츠를 렌더링한다.
 * - 생성중/로딩 상태
 * - 타입별 View로 위임
 */
export default function StudyArtifactContentCardBody({
  artifact,
  studyId,
  studyName,
  isGenerating,
  generationStep,
  getGenerationSteps,
  isEditing,
  editor,
  parseSurveyData,
  handleSaveSurveyJS,
  handleOpenDistributeModal,
  handleSave,
  handleCancelEdit,
  handleCopy,
  handleDownloadWord,
  handleDownloadPDF,
  handleDownloadMarkdown,
  handleShare,
  handleDelete,
  onArtifactUpdate,
  onDirectEdit,
}) {
  if (isGenerating || artifact.status === "pending") {
    return (
      <ArtifactLoadingState
        artifactType={artifact.artifact_type}
        generationStep={generationStep}
        getGenerationSteps={getGenerationSteps}
      />
    );
  }

  switch (artifact.artifact_type) {
    case "survey":
      return (
        <SurveyArtifactView
          artifact={artifact}
          parseSurveyData={parseSurveyData}
          onSave={handleSaveSurveyJS}
          onDistribute={handleOpenDistributeModal}
          isEditing={isEditing}
          isGenerating={isGenerating}
          onCancelEdit={handleCancelEdit}
          onCopy={handleCopy}
          onDownloadWord={handleDownloadWord}
          onDownloadPDF={handleDownloadPDF}
          onDownloadMarkdown={handleDownloadMarkdown}
          onDelete={handleDelete}
        />
      );
    case "guideline":
      return (
        <GuidelineArtifactView
          artifact={artifact}
          studyId={studyId}
          studyName={studyName}
          isEditing={isEditing}
          isGenerating={isGenerating}
          editor={editor}
          onSave={handleSave}
          onCancelEdit={handleCancelEdit}
          onCopy={handleCopy}
          onDownloadWord={handleDownloadWord}
          onDownloadPDF={handleDownloadPDF}
          onDownloadMarkdown={handleDownloadMarkdown}
          onDelete={handleDelete}
          onArtifactUpdate={onArtifactUpdate}
          onDirectEdit={onDirectEdit}
        />
      );
    case "plan":
    default:
      return (
        <PlanArtifactView
          artifact={artifact}
          studyId={studyId}
          studyName={studyName}
          isEditing={isEditing}
          isGenerating={isGenerating}
          editor={editor}
          onSave={handleSave}
          onCancelEdit={handleCancelEdit}
          onCopy={handleCopy}
          onDownloadWord={handleDownloadWord}
          onDownloadPDF={handleDownloadPDF}
          onDownloadMarkdown={handleDownloadMarkdown}
          onShare={handleShare}
          onDelete={handleDelete}
          onArtifactUpdate={onArtifactUpdate}
          onDirectEdit={onDirectEdit}
        />
      );
  }
}

